'use strict';
import React from 'react';
import * as ReactDOM from 'react-dom';
import '@/scss/_reset.scss';
import { fontSize } from '@/lib/utils';
import Container from './container';
fontSize(375, 100);
var App = function () {
    // useEffect(() => {
    //   const obj = siteUrl.find(
    //     item => item.siteId === +(process.env as any).SITE_ID
    //   ) as any;
    //   let url = obj.url.pro;
    //   if (process.env.EVIROMENT === 'testing') {
    //     url = obj.url.test;
    //   }
    //   // if (isOnIPhone) {
    //   //   location.href = url;
    //   // }
    //   // console.log('aaaaaaaaa');
    // }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null)));
};
var app = document.getElementById('app');
ReactDOM.render(React.createElement(App, null), app);
